import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'config/config';
import { Provider } from 'react-redux';
import { store } from '@app/store/store';
import ReactDOM from 'react-dom';
import React from 'react';
import keycloak from './keycloak';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { HelmetProvider } from 'react-helmet-async';

const KEYCLOAK_ATTENTION_EVENTS = new Set([
  'onInitError',
  'onAuthError',
  'onAuthRefreshError',
]);

const keycloakEventLogger = (event: string, error?: unknown) => {
  if (
    process.env.NODE_ENV === 'production' ||
    !KEYCLOAK_ATTENTION_EVENTS.has(event)
  ) {
    return;
  }

  const detail = error instanceof Error ? `: ${error.message}` : '';
  console.warn(`[Keycloak] ${event}${detail}`);
};

ReactDOM.render(
  <React.StrictMode>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'login-required',
        checkLoginIframe: false,
        messageReceiveTimeout: 10000,
        pkceMethod: 'S256',
      }}
      onEvent={keycloakEventLogger}
    >
      <Provider store={store}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider>
    </ReactKeycloakProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
